import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {TextField, SelectField} from 'redux-form-material-ui';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem'
import {Redirect} from "react-router";

import FlatButton from 'material-ui/FlatButton';

import {addPackage, putPackages} from "store/packages/actions";
import {generateId} from "store/auth/utils";
import {increaseLocalIncrement} from "store/auth/actions";
import {checkRequiredFields} from "forms";
import {sortAlphabetically} from "utils";
import {translate} from "react-i18next";


class PackageForm extends Component {

    saveRef = ref => (this.ref = ref);

    componentDidMount() {
        this.ref // the Field
            .getRenderedComponent() // on Field, returns ReduxFormMaterialUITextField
            .getRenderedComponent() // on ReduxFormMaterialUITextField, returns TextField
            .focus() // on TextField
    }

    render() {
        const langsSorted = sortAlphabetically(this.props.langs, 'name');
        let langChoices = langsSorted.map(lang => {
            const langName = lang.name + " (" + lang.native_name +  ")";
            return <MenuItem key={lang.id} value={lang.id} primaryText={langName}/>
        });
        return (
            <form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <Field maxLength={100} name="name" component={TextField} hintText={this.props.t('package_management_new_package_name')} ref={this.saveRef} withRef/><br/>
                <Field style={{marginRight: '10px'}} name="native_language" component={SelectField} hintText={this.props.t('package_management_know')}>
                    {langChoices}
                </Field>
                <Field name="foreign_language" component={SelectField} hintText={this.props.t('package_management_want_to_know')}>
                    {langChoices}
                </Field>
                <div style={{textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px'}}>
                    {this.props.actions}
                </div>
            </form>
        )
    }
}

PackageForm = reduxForm({
    form: 'packageForm'
})(translate()(PackageForm));


class PackageDialog extends Component {

    constructor() {
        super();
        this.state = {
            open: false,
            redirect: false,
        };
        // this.handleOnClick.bind(this);
    }

    handleOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClose = () => {
        this.setState({open: false});
    };

    sendForm = (values) => {
        checkRequiredFields(['name', 'native_language', 'foreign_language'], values);
        return (dispatch, getState) => {
            const state = getState();
            const id = generateId(state.auth.deviceId, state.auth.localIncrement);
            const pckg = {...values, id};
            dispatch(increaseLocalIncrement());
            this.handleClose();
            dispatch(addPackage(pckg));
            dispatch(putPackages());
            this.setState({redirect: '/package/'+id});
        }
    };

    submitForm = (values, dispatch) => {
        return dispatch(this.sendForm(values));
    };

    render() {
        if (this.state.redirect !== false) {
            return <Redirect to={this.state.redirect}/>
        }
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                // primary={true}
                onClick={this.handleClose}
                key="cancel"
            />,
            <FlatButton
                type="submit"
                label={this.props.t('dialog_save')}
                primary={true}
                keyboardFocused={true}
                key="submit"
                // onClick={this.handleClose}
            />,
        ];
        const Wrapper = this.props.wrapper;
        const Icon = this.props.icon;
        let icon = null;
        if (Icon) {
            icon = <Icon style={this.props.iconStyle} />
        }
        return (

            <Wrapper {...this.props.wrapperProps} onClick={this.handleOpen}>
                {icon}
                <Dialog autoScrollBodyContent={true} open={this.state.open} title={this.props.t('create_package')}>
                    <PackageForm initialValues={this.props.formInitialValues} actions={actions} langs={this.props.langs} onSubmit={this.submitForm}/>
                </Dialog>
            </Wrapper>

        )
    }
}

const mapStateToProps = (state) => {
    return {langs: state.lang.languages}
};

export default connect(mapStateToProps)(translate()(PackageDialog));




// WEBPACK FOOTER //
// ./src/components/packages/PackageAddDialog.js